module.exports = __webpack_public_path__ + "r-v3/img/icon_mic_on.901ab420.svg";